import * as React from 'react';

import {Illustration} from '../illustrations/illustration';

import styles from './option-card-content.module.css';

export const illustrationMap: Record<string, string> = {
    'audience-group': 'audience',
    'audience-people-related-companies': 'people-related-companies',
    'audience-people-related-leads': 'people-related-leads',
    'audience-people': 'people',
    'contact-us': 'contact-us',
    'content-download': 'content-download',
    'dashboard-leaderboard': 'dashboard-leaderboard',
    'dashboard-list-summaries': 'dashboard-list-summaries',
    'dashboard-lists': 'dashboard-lists',
    'dashboard-metrics': 'dashboard-metrics',
    'dashboard-pipeline': 'dashboard-pipeline',
    'dashboard-quotas': 'dashboard-quotas',
    'email-template-bear': 'email-template-bear',
    'email-template-event': 'email-template-event',
    'email-template-proposal': 'email-template-proposal',
    'email-template-question': 'email-template-question',
    'import-another-crm': 'import-another-crm',
    'import-constant-contact': 'import-constant-contact',
    'import-mailchimp': 'import-mailchimp',
    'import-spreadsheet': 'import-spreadsheet',
    'join-mailing-list': 'join-mailing-list',
    'magnifying-glass': 'magnifying-glass',
    'sales-request': 'sales-request',
    'saved-list': 'saved-list',
    'sharing-everyone': 'sharing-everyone',
    'sharing-individual': 'sharing-individual',
    'sharing-team': 'sharing-team',
    custom: 'custom',
};

export type Props = {
    title: string;
    subtitle: string;
    illustration: keyof typeof illustrationMap;
};

export function OptionCardContent(props: Props) {
    const illustrationFile = illustrationMap[props.illustration];

    return (
        <div className={styles['option-card-chooser']}>
            <div className={styles.illustration}>
                {illustrationFile ? (
                    <Illustration src={`option-card-chooser/${illustrationFile}`} />
                ) : null}
            </div>
            <div className={styles.title}>{props.title}</div>
            <div className={styles.subtitle}>{props.subtitle}</div>
        </div>
    );
}
